<template>
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-xl-between">
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
